
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1501_NDialog extends Serenity.EntityDialog<Report_1501_NRow, any> {
        protected getFormKey() { return Report_1501_NForm.formKey; }
        protected getIdProperty() { return Report_1501_NRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1501_NRow.localTextPrefix; }
        protected getNameProperty() { return Report_1501_NRow.nameProperty; }
        protected getService() { return Report_1501_NService.baseUrl; }
        protected getDeletePermission() { return Report_1501_NRow.deletePermission; }
        protected getInsertPermission() { return Report_1501_NRow.insertPermission; }
        protected getUpdatePermission() { return Report_1501_NRow.updatePermission; }

        protected form = new Report_1501_NForm(this.idPrefix);

    }
}